export default __webpack_public_path__ + "335ab2a4a1f33f6b2367d557003cd576.png";